import React from 'react';

/**
 * 모바일 하단 이동 메뉴 — VIMS 와 같은 형태 (2026-09-23)
 *
 * PC 는 상단 바의 '시스템 전환' 메뉴(public/switcher.js)로 네 시스템을 오갈 수 있는데,
 * 모바일에는 그 자리가 없어서 다른 시스템으로 가려면 주소를 직접 쳐야 했다.
 * VIMS 모바일(m_vims.html)이 쓰는 하단 탭바와 같은 모양·같은 높이로 맞춘다.
 *
 * ※ 지금은 '링크'다. 눌러 이동하면 그 시스템의 로그인 화면이 나오고
 *   브라우저에 저장된 비밀번호가 채워진다. (PC 전환 메뉴와 동작이 같다)
 */

// 내가 지금 있는 시스템(CRM)을 맨 앞에 두고, 나머지를 순서대로 — VIMS 하단 바와 같은 구성
const SYSTEMS = [
  { key: 'crm',  icon: '📇', label: '고객CRM',  url: 'https://crm.e2bility.net' },
  { key: 'team', icon: '💬', label: '통합소통', url: 'https://team.e2bility.net' },
  { key: 'vims', icon: '🚗', label: 'VIMS',    url: 'https://vims.e2bility.net' },
  { key: 'eims', icon: '🚚', label: 'eIMS',    url: 'https://eims.e2bility.net' }
];

const ACTIVE_COLOR = '#6366f1'; // 전환 메뉴에서 CRM 에 쓰는 색과 같다

const S = {
  nav: {
    display: 'flex', justifyContent: 'space-around', alignItems: 'center',
    height: '60px', flexShrink: 0,
    background: '#ffffff', borderTop: '1px solid #e2e8f0',
    paddingBottom: 'env(safe-area-inset-bottom)', boxSizing: 'content-box'
  },
  item: {
    display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
    gap: '4px', flex: 1, height: '100%',
    color: '#64748b', fontSize: '0.7rem', fontWeight: 600,
    textDecoration: 'none', background: 'none', border: 'none',
    cursor: 'pointer', fontFamily: 'inherit', padding: 0
  },
  icon: { fontSize: '1.1rem', lineHeight: 1 }
};

export default function MobileSystemNav({ current = 'crm', onCurrentClick }) {
  return (
    <nav style={S.nav}>
      {SYSTEMS.map((sys) => {
        const isHere = sys.key === current;
        const style = isHere
          ? { ...S.item, color: ACTIVE_COLOR, fontWeight: 900 }
          : S.item;

        // 지금 있는 시스템은 이동하지 않고 맨 위로 올린다 (VIMS 하단 바와 같은 동작)
        if (isHere) {
          return (
            <button key={sys.key} type="button" style={style} onClick={onCurrentClick} aria-current="page">
              <span style={S.icon}>{sys.icon}</span>
              <span>{sys.label}</span>
            </button>
          );
        }
        return (
          <a key={sys.key} href={sys.url} style={style}>
            <span style={S.icon}>{sys.icon}</span>
            <span>{sys.label}</span>
          </a>
        );
      })}
    </nav>
  );
}
